import React from "react";

const Loader = ({ message = "Loading..." }) => (
  <div className="flex flex-col items-center justify-center py-8">
    <div className="loader-spinner mb-4"></div>
    <span className="text-gray-700 font-medium">{message}</span>
    <style>
      {`
        .loader-spinner {
          border: 4px solid #e5e7eb;
          border-top: 4px solid #2563eb;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% { transform: rotate(0deg);}
          100% { transform: rotate(360deg);}
        }
      `}
    </style>
  </div>
);

export default Loader;
